module.exports = __webpack_public_path__ + "img/carbs-img-3.da5adc0c.png";